export const getCampaignPerformanceUrl =
  "/api/v3/campaign/:campaignId/performance";
export const getCampaignPerformanceMapUrl = "/api/v3/campaign/plan/list";
